import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookHeart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBookHeart"><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H20V22ZM7 18C6.44772 18 6 18.4477 6 19C6 19.5523 6.44772 20 7 20H18V18H7ZM15.251 9.66797C15.2508 7.92017 13.5026 6.87862 11.999 7.84961C10.4956 6.87912 8.74827 7.92034 8.74805 9.66797C8.74836 11.9856 11.9588 13.2644 11.999 13.2803C12.021 13.2716 15.2507 11.9923 15.251 9.66797Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookHeart;
